import { Controller } from '@hotwired/stimulus'

// Filters kanban cards by visible text, keeping each column's count in sync.
// Cards arrive/leave independently of any active search (broadcast board
// moves), so a MutationObserver reapplies the query to whatever just changed.
export default class extends Controller {
  static targets = ['input']

  connect() {
    this.observer = new MutationObserver(() => this.filter())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer.disconnect()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()

    // Disconnect first: updating a count's text below is itself a childList
    // mutation inside the observed subtree, and would otherwise re-trigger
    // this same callback forever.
    this.observer.disconnect()

    this.element.querySelectorAll('.kanban__column').forEach((column) => {
      let visibleCount = 0

      column.querySelectorAll('.policy-application-card').forEach((card) => {
        const matches = !query || card.textContent.toLowerCase().includes(query)
        if (card.hidden !== !matches) card.hidden = !matches
        if (matches) visibleCount += 1
      })

      // Only touch textContent when the count actually changed — it's a
      // childList mutation, and rewriting it unconditionally on every
      // trigger used to retrigger other childList observers on this same
      // subtree (see card_ordering_controller.js) whether or not anything
      // meaningful had changed.
      const countElement = column.querySelector('.kanban__column-count')
      if (countElement && countElement.textContent !== String(visibleCount)) {
        countElement.textContent = visibleCount
      }
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }
}
